import { useNavigate } from "react-router-dom";
import { PAGE_NAME_TOP } from "../../../../constants/common_constants";
import { useTranslation } from "react-i18next";
import { useApi, useErrorDialog } from "../../../../hooks";
import { updateDisclaimerAgreeStatus } from "../../../api/dts_api_wrapper";

interface DisclaimerNextPageButtonProps {
  disabled: boolean;
  userId: string;
  version: string;
}

export const DisclaimerNextPageButton: React.FC<
  DisclaimerNextPageButtonProps
> = ({ disabled, userId, version }) => {
  // ページ遷移用
  const navigate = useNavigate();
  //言語切替用
  const { t } = useTranslation();
  //API用
  const { handleApi } = useApi();

  // エラーダイアログ
  const { showErrorDialog } = useErrorDialog();

  //次へボタンをクリックした際の処理
  const handleOnAgreeButton = async () => {
    if (!userId || !version) {
      if (!userId) console.error("userId is unknown");
      if (!version) console.error("version is unknown");
      //TODO:遷移先の決定 パラメータ不足での取得失敗のとき, トップ画面に遷移する
      showErrorDialog(
        t("共通エラーポップ.エラー"),
        t("共通エラーポップ.通信エラーが発生しました。"),
        "navigateToTopPage"
      ); //エラー", "通信エラーが発生しました。(トップページに遷移する)
      return; // パラメータ不足の場合は処理を終了
    }

    try {
      //免責事項同意状態の更新
      const disclaimerAgreeStatusResult = await handleApi(
        updateDisclaimerAgreeStatus,
        userId,
        version
      );
      //エラー時はuseApiの処理にする(エラーダイアログを表示し, 遷移しない)
      if ("errorMessage" in disclaimerAgreeStatusResult) {
        console.log("errorMessage: ", disclaimerAgreeStatusResult.errorMessage);
        throw new Error("failed to update disclaimer agree status");
      }
      //トップ画面に遷移, ブラウザバック等で免責事項画面に戻らないように設定
      navigate(`/${PAGE_NAME_TOP}`, { replace: true });
    } catch (err) {
      console.log("[Disclaimer]handleOnAgreeButton err:", err);
      if (
        err instanceof Error &&
        (err.message === "Expired token" || err.message === "Invalid token")
      ) {
        //LocalStorageのセッション情報クリア
        const userpool_client_id =
          process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? "";
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.accessToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.refreshToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.idToken`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.clockDrift`
        );
        localStorage.removeItem(
          `CognitoIdentityServiceProvider.${userpool_client_id}.LastAuthUser`
        );

        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.セッションがタイムアウトしました。"),
          "ydsyos"
        ); //エラー", "セッションがタイムアウトしました。(YDS/YOSに遷移する)
      } else {
        showErrorDialog(
          t("共通エラーポップ.エラー"),
          t("共通エラーポップ.通信エラーが発生しました。")
        ); //エラー", "通信エラーが発生しました。
      }
    }
  };

  return (
    <div className="py-1">
      <button
        onClick={handleOnAgreeButton}
        disabled={disabled}
        className={`${
          !disabled
            ? "border-main-red bg-white"
            : "text-gray-500 border-gray-500 bg-gray-300"
        } rounded-full border-2 py-1 px-6 w-40 overflow-hidden whitespace-nowrap`}
      >
        <span className="font-bold text-[20px]"> {t("免責事項画面.次へ")}</span>
        {/* 次へ */}
      </button>
    </div>
  );
};
